<template>
  <div>
    <div class="calendar-header subtitle has-text-weight-bold">
      <h4>{{ month + ' ' + year }}</h4>
    </div>

    <div class="content">
      <!-- Numéros de semaines -->
      <div class="weeks">
        <div class="week has-text-weight-semibold">N°</div>
        <div
          class="week has-text-weight-semibold"
          v-for="(w, index) in weeks"
          :key="'num-' + index"
        >
          {{ w.number }}
        </div>
      </div>

      <!-- Lettres de semaines -->
      <div class="weeks">
        <div class="week has-text-weight-semibold">.</div>
        <div
          class="week has-text-weight-semibold"
          v-for="(w, index) in weeks"
          :key="'let-' + index"
          :class="w.letter"
        >
          {{ w.letter.toUpperCase() }}
        </div>
      </div>

      <!-- Calendrier -->
      <div class="calendar">
        <div
          class="has-text-weight-semibold"
          v-for="day in weekdays"
          :key="day"
        >
          {{ day }}
        </div>

        <div
          v-for="(day, index) in days"
          :key="index"
          :style="{ gridColumn: column(index) }"
          :class="dayStyle(day)"
        >
          {{ day.format('D') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Month",
  props: ["date"],

  data() {
    return {
      weekdays: ["L", "Ma", "Me", "J", "V", "S", "D"],
      days: [],
      weeks: [],
      month: "",
      year: ""
    };
  },

  mounted() {
    this.month = this.date.format("MMMM");
    this.year = this.date.format("Y");

    const seenWeeks = new Set();

    this.days = [...Array(this.date.daysInMonth())].map((_, i) => {
      const day = this.date.clone().add(i, "day");

      const key = `${day.isoWeekYear()}-${day.isoWeek()}`;

      if (!seenWeeks.has(key)) {
        seenWeeks.add(key);

        this.weeks.push({
          number: day.isoWeek(),
          letter: this.getWeekLetter(day)
        });
      }

      return day;
    });

    window.scrollTo(0, 0);
  },

  methods: {
    column(index) {
      if (index === 0) {
        return this.days[0].isoWeekday();
      }
    },

    today(day) {
      return this.$moment().isSame(day, "day");
    },

    closed(day) {
      return (
        (day.month() === 0 && day.date() === 1) ||
        (day.month() === 3 && day.date() === 6) ||
        (day.month() === 4 && day.date() === 1) ||
        (day.month() === 4 && day.date() === 25) ||
        (day.month() === 6 && day.date() === 14) ||
        (day.month() === 7 && day.date() === 15) ||
        (day.month() === 11 && day.date() === 25)
      );
    },

    /**
     * 🔑 Source unique de vérité
     * Offset métier = +2
     */
    getWeekLetter(day) {
      const base = this.$moment("2020-01-06"); // lundi ISO semaine 1 / 2020

      const absoluteWeek = day
        .clone()
        .startOf("isoWeek")
        .diff(base, "weeks");

      const OFFSET = 2; // <-- décalage métier
      const letterIndex = ((absoluteWeek + OFFSET) % 4 + 4) % 4;

      return String.fromCharCode(65 + letterIndex).toLowerCase();
    },

    countDown(day) {
      return day.isoWeekday() === 4; // jeudi
    },

    dayStyle(day) {
      return {
        closed: this.closed(day),
        today: this.today(day),
        countDown: this.countDown(day),
        [this.getWeekLetter(day)]: this.countDown(day)
      };
    }
  }
};
</script>

<style lang="css" scoped>

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  .modal {
    transform: rotate(-90deg);
    transform-origin: left top;
    width: 100vh;
    height: 100vw;
    overflow-x: hidden;
    position: absolute;
    top: 100%;
    left: 0;
  }
}

.calendar{
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  max-width: 1024px;
  width: 78%;
}

.calendar > *{
  align-items: center;
  display: flex;
  justify-content: center;
}

.calendar > *::before{
  content: "";
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 1px;
}

.calendar > *.today{
  border: 2px solid #ff4200;
  border-radius: 100%;
  margin: 5px;
}

.calendar-header {
  text-align: center;
  background-color: #737479;
  color: white;
  border-radius: 20px;
  padding: 5px;
  text-transform: capitalize;
  width: 100%;
}

.weeks {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 1024px;
  width: 11%;
  text-align: center;
}

.week {
  flex: 1;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.month {
  width: 100%;
}

.content {
  display: flex;
  flex-direction: row;
}

.a, .b, .c, .d {
  color: black;
}

.a, .b, .c, .d {
  border-radius: 100%;
}

.a {
  background-color: #FBECB8;
}
.b {
  background-color: #b9e2f1;
}
.c {
  background-color: #ffb3a3;
}
.d {
  background-color: #C3DEBE;
}

.calendar > *.countDown {
  color: black;
  border-radius: 100%;
  margin: 5px;
}

.calendar > *.closed {
  border-radius: 100%;
  margin: 5px;
  background:
    linear-gradient(45deg, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 48%,#737479 49%,#737479 50%,rgba(0,0,0,0) 51%,rgba(0,0,0,0) 100%),
    linear-gradient(135deg, #f2f6fa 0%,#f2f6fa 48%,#737479 49%,#737479 50%,#f2f6fa 51%,#f2f6fa 100%);
}
</style>
